import * as Types from '../../../../../../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRecommendedCatalogProductsQueryVariables = Types.Exact<{
  eventId?: Types.InputMaybe<Types.Scalars['ID']>;
  first: Types.Scalars['Int'];
  endCursor?: Types.InputMaybe<Types.Scalars['ProductCatalogEntityCursor']>;
  storefront?: Types.InputMaybe<Types.CatalogStorefront>;
}>;

export type GetRecommendedCatalogProductsQuery = {
  __typename?: 'Query';
  recommendCatalogHomeSections: {
    __typename: 'ProductCatalogPageSectionContainer';
    id?: string | null;
    sections: Array<{
      __typename: 'ProductCatalogPageSection';
      id: string;
      displayType: string;
      paginatedCatalogEntities: {
        __typename: 'ProductCatalogEntitiesPagination';
        pageInfo: {
          __typename?: 'ProductCatalogEntitiesPageInfo';
          startCursor?: any | null;
          endCursor?: any | null;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          totalCount: number;
        };
        edges: Array<{
          __typename?: 'ProductCatalogEntityEdge';
          cursor: any;
          node:
            | { __typename: 'ProductCatalogEntityBrand'; id: string }
            | { __typename: 'ProductCatalogEntityCategory'; id: string }
            | { __typename: 'ProductCatalogEntityCuration'; id: string }
            | { __typename: 'ProductCatalogEntityItem'; id: string }
            | {
                __typename: 'ProductCatalogEntityItemGroup';
                id: string;
                catalogItemGroupData?: {
                  __typename?: 'ProductCatalogItemGroup';
                  id: string;
                  tileViewItem?: {
                    __typename: 'ProductCatalogItem';
                    id: string;
                    title: string;
                    itemType: string;
                    productUrl?: string | null;
                    isFullPrice: boolean;
                    tags: Array<string>;
                    group?: {
                      __typename: 'ProductCatalogItemGroup';
                      id: string;
                      tileViewDimension?: {
                        __typename?: 'ProductCatalogItemGroupDimension';
                        id: string;
                        title: string;
                        swatchType: Types.GroupDimensionSwatchType;
                        options: Array<{
                          __typename?: 'ProductCatalogItemGroupDimensionOption';
                          id: string;
                          displayString: string;
                          swatchColor?: { __typename?: 'Color'; hex: string; isLight: boolean } | null;
                        }>;
                      } | null;
                      items: Array<{
                        __typename?: 'ProductCatalogItem';
                        id: string;
                        title: string;
                        itemType: string;
                        productUrl?: string | null;
                        isFullPrice: boolean;
                        tags: Array<string>;
                        groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption'; id: string }>;
                        brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
                        photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
                        price?: {
                          __typename?: 'MonetaryValue';
                          valueInMinorUnits: number;
                          floatingPointDecimalString: string;
                          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                        } | null;
                        fullPrice?: {
                          __typename?: 'MonetaryValue';
                          valueInMinorUnits: number;
                          floatingPointDecimalString: string;
                          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                        } | null;
                        storefrontInfo: {
                          __typename?: 'ProductCatalogStorefrontInfo';
                          storefrontStatus: Types.ProductCatalogStorefrontStatus;
                          canAddToCart: boolean;
                          canAddToRegistry: boolean;
                        };
                        rating?: {
                          __typename?: 'RatingProduct';
                          id: string;
                          stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number };
                        } | null;
                      }>;
                    } | null;
                    brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
                    photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
                    price?: {
                      __typename?: 'MonetaryValue';
                      valueInMinorUnits: number;
                      floatingPointDecimalString: string;
                      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                    } | null;
                    fullPrice?: {
                      __typename?: 'MonetaryValue';
                      valueInMinorUnits: number;
                      floatingPointDecimalString: string;
                      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                    } | null;
                    storefrontInfo: {
                      __typename?: 'ProductCatalogStorefrontInfo';
                      storefrontStatus: Types.ProductCatalogStorefrontStatus;
                      canAddToCart: boolean;
                      canAddToRegistry: boolean;
                    };
                    rating?: {
                      __typename?: 'RatingProduct';
                      id: string;
                      stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number };
                    } | null;
                  } | null;
                } | null;
              };
        }>;
      };
    }>;
  };
};

export const GetRecommendedCatalogProductsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRecommendedCatalogProducts' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endCursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogEntityCursor' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'storefront' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CatalogStorefront' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendCatalogHomeSections' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'storefront' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'storefront' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sections' },
                  arguments: [
                    { kind: 'Argument', name: { kind: 'Name', value: 'offset' }, value: { kind: 'IntValue', value: '1' } },
                    { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paginatedCatalogEntities' },
                        arguments: [
                          { kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } } },
                          { kind: 'Argument', name: { kind: 'Name', value: 'after' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'endCursor' } } },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogEntityItemGroup' } },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'catalogItemGroupData' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'tileViewItem' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'group' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductTileViewDimensions' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'productUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'storefrontInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'storefrontStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToCart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToRegistry' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogProductTileViewDimensions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItemGroup' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tileViewDimension' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'swatchType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayString' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'swatchColor' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupDimensionOptions' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Color' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Color' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRecommendedCatalogProductsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedCatalogProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedCatalogProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedCatalogProductsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      first: // value for 'first'
 *      endCursor: // value for 'endCursor'
 *      storefront: // value for 'storefront'
 *   },
 * });
 */
export function useGetRecommendedCatalogProductsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>(GetRecommendedCatalogProductsDocument, baseOptions);
}
export function useGetRecommendedCatalogProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>(GetRecommendedCatalogProductsDocument, baseOptions);
}
export type GetRecommendedCatalogProductsQueryHookResult = ReturnType<typeof useGetRecommendedCatalogProductsQuery>;
export type GetRecommendedCatalogProductsLazyQueryHookResult = ReturnType<typeof useGetRecommendedCatalogProductsLazyQuery>;
export type GetRecommendedCatalogProductsQueryResult = Apollo.QueryResult<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>;
